import { useQuery } from "@tanstack/react-query";

import { listDepartments } from "../api/lookups";
import type { PennDepartment } from "../types/auth-types/AuthUser";

export function useDepartments() {
  return useQuery<PennDepartment[]>({
    queryKey: ["lookups", "departments"],
    queryFn: listDepartments,
    staleTime: 5 * 60 * 1000,
  });
}
